<template>
    <div class="vue-map-container">
        <gmap-map ref="map" :center="center" :zoom="8">
            <div
            v-for="(route, name) in allMessengers"
            :key="name + '_messenger'">
                <GmapMarker ref="myMarker"
                            v-for="(point ,index) in route.route.legs"
                            :key="index"
                            :label="getLabel(point.data ,index)"
                            :icon="getIcon(point.data)"
                            @click="setActivePoint(point.data, index)"
                            :position="point.point"/>
            </div>
        </gmap-map>
        <v-dialog v-model="dialog" max-width="700" ref="dialog">
            <v-popup :data-to-use="activePoint"
                     ref="vpopup"
                     @closeModal="closeModal()"
                     @showLoader="showLoader()"
                     @successSubmit="successSubmit"
                     @showSnackbar="showSnackbar"></v-popup>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                :color="snackBarClass"
        >
            {{ snackbarText }}
            <v-btn
                    :color="'white'"
                    text
                    @click="snackbar = false"
            >
                סגירה
            </v-btn>
        </v-snackbar>
        <v-overlay :value="overlay" class="overlayLoader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import {gmapApi} from 'vue2-google-maps'
    import vPopup from './vPopup'
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import {HTTP} from '../http/http-common.js';


    export default {
        components: {
            'gmap-custom-marker': GmapCustomMarker,
            vPopup
        },
        data() {
            return {
                directionsService: [],
                directionsDisplay: [],
                allMessengers:{},
                colors: ['blue', 'green', 'purple', 'orange', 'pink', 'red'],
                isModalVisible: false,
                clickedPoint: null,
                google: gmapApi,
                userLocation: {},
                route: [],
                center: {
                    lat: 32,
                    lng: 35
                },
                activePoint: null,
                activeIndex: null,
                snackBarClass: 'success',
                isPopupShown: false,
                dialog: false,
                snackbarText: '',
                timeout: 5000,
                snackbar: false,
                overlay: false,
            }
        },
        watch: {
            dialog () {
                let poup = this.$refs.vpopup;
                if(poup != null){
                    this.$refs.vpopup.reset();
                }
            }
        },
        computed: {
            customViewCall() {
                let params = new URLSearchParams(location.search);
                return params.get('day') || 'today';
            }
        },
        created() {

        },
        beforeMount(){
            this.getPointsFromCustomView();
            this.getCurrentLocation()
        },
        mounted() {


        },
        methods: {
            getCurrentLocation: function(){
                let self = this;
                //get user location
                //do we support geolocation
                if (!("geolocation" in navigator)) {
                    return;
                }
                let options;
                function success(pos) {
                    //check if user connected can save location
                    let user_zoho = window.localStorage.getItem('zoho_name');
                    if(user_zoho != null) {
                        var crd = pos.coords;
                        console.log("messenger cords: ");
                        console.log(crd);
                        //updated location of our messenger
                        //if location data is not set, get them
                        if(!self.userLocation[user_zoho]){
                            self.getLocation();
                        } else {
                            self.userLocation[user_zoho].lat = crd.latitude;
                            self.userLocation[user_zoho].lng = crd.longitude;
                        }
                        //save location
                        self.saveLocation(crd);
                        //save location only if got route
                        if(self.allMessengers[user_zoho] && self.allMessengers[user_zoho].route.legs && self.allMessengers[user_zoho].route.legs.length) {
                            self.allMessengers[user_zoho].route.legs[0].point.lat = crd.latitude;
                            self.allMessengers[user_zoho].route.legs[0].point.lng = crd.longitude;
                            //self.saveLocation(crd);
                        }
                    }
                }
                function error(err) {
                    console.warn('ERROR(' + err.code + '): ' + err.message);
                }

                options = {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                };

                // (navigator.userAgent.indexOf('SM-T585') > -1 || navigator.userAgent.indexOf('T585') > -1) { // add this if you want to save location from messenger only, change "GM1910" to messenger phone type
                if (window.localStorage.getItem('role') !== null && window.localStorage.getItem('role') === 'messenger') { // add this if you want to save location from messenger only, change "GM1910" to messenger phone type
                     setInterval(function () {
                         navigator.geolocation.getCurrentPosition(success, error, options);
                     },10000)
                    // let id = navigator.geolocation.watchPosition(success, error, options);
                } else {
                         setInterval(function () {
                             self.getLocation()
                         },5000)


                }
            },
            //open popup modal
            showModal(point) {
                this.clickedPoint = point.name;
                this.isModalVisible = true;
                this.$refs.signaturePad.clearSignature();
                this.$refs.signaturePad.resizeCanvas();
            },
            //close popup modal
            closeModal() {
                this.isModalVisible = false;
                this.dialog = false;
            },
            //get points from custom view using customViewCall param
            getPointsFromCustomView() {
                this.overlay = true;
                let self = this;
                HTTP.get('deals/' + this.customViewCall).then(function (resp) {
                    if(resp && Object.keys(resp).length) {

                        // At this point, the child GmapMap has been mounted, but
                        // its map has not been initialized.
                        // Therefore we need to write mapRef.$mapPromise.then(() => ...)
                        //TODO : pan to the first point of the navigation
                        self.$refs.map.$mapPromise.then((map) => {
                            //call function to get route
                            self.getDirection(resp);
                        });
                        let data = {
                            text: 'הנקודות למשלוח נטענו בהצלחה!',
                            status: 'success'
                        }
                        self.showSnackbar(data);
                    } else {
                        let data = {
                            text: 'לא קיימות נקודות למשלוח',
                            status: 'orange'
                        }
                        self.showSnackbar(data);
                    }

                })
                    .catch(function (resp) {
                        if(resp.message === "There is no content available for the request.") {
                            let data = {
                                text: 'לא קיימות נקודות למשלוח',
                                status: 'orange'
                            }
                            self.showSnackbar(data);
                        } else {
                            let data = {
                                text: 'שגיאה בטעינת נקודות',
                                status: 'error'
                            }
                            self.showSnackbar(data);
                        }
                        console.log(resp);
                    });
            },
            saveLocation: function(pos){
                let self = this;
                let data = {
                    lat: pos.latitude,
                    lng: pos.longitude,
                }
                HTTP.post('setlocation', data).then(function (resp) {
                })
                    .catch(function (resp) {
                        let data = {
                            text: 'שגיאה בשמירת המיקום לשרת',
                            status: 'error'
                        }
                        self.showSnackbar(data);
                        console.log(resp);
                    });
            },
            getLocation: function () {
                let self = this;
                HTTP.get('getlocation/').then(function (resp) {
                    self.userLocation = resp;

                    for (let user in self.allMessengers) {
                        if (resp[user]) {
                            let point = self.allMessengers[user].route.legs[0].point;
                            point.lat = resp[user].lat;
                            point.lng = resp[user].lng;
                        }
                    }
                }).catch(function (resp) {
                    let data = {
                        text: 'שגיאה בקבלת מיקום השליח',
                        status: 'error'
                    }
                    self.showSnackbar(data);
                    console.log(resp);
                });
            },
            /** Function on submit **/
            successSubmit: function successSubmit(point){
                this.dialog = false;
                for (let user in this.allMessengers) {
                    let legs = this.allMessengers[user].route.legs;
                    if(this.activeIndex) {
                        legs.splice(this.activeIndex, 1);
                        break;
                    }
                }
                window.location.reload();
            },
            setActivePoint: function (point,index) {
                this.activeIndex = null;
                if (point.Contact_Type !== 'נהג') {
                    this.isPopupShown = true;
                    this.dialog = true;
                    this.activePoint = point;
                    this.activeIndex = index;
                }
            },
            //function to get direction from google api
            getDirection: function (pointsToMap) {
                this.overlay = true;
                this.allMessengers = {};

                let self = this;

                function calculateAndDisplayRoute(userLocation, waypoints, pointsToMap, messengerName, index) {
                    self.directionsDisplay[index].setOptions({
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor: self.colors[index]
                        }});
                    self.directionsService[index].route({
                        origin: userLocation,
                        //TODO: Set destination after calculation
                        destination: 'שכניה',
                        waypoints: waypoints,
                        optimizeWaypoints: true,
                        travelMode: 'DRIVING'
                    }, function (response, status) {
                        self.overlay = false;

                        if (status === 'OK') {
                            //set directions on the map
                            self.directionsDisplay[index].setDirections(response);
                            //set route labels
                            self.route = response.routes[0];
                            //loop on route received from GoogleMaps API and set the point object
                            self.route.waypoint_order.forEach(function (singlePoint, index) {
                                let point = waypoints[singlePoint]; //store the data in point
                                self.$set(self.route.legs[index + 1], 'data', pointsToMap[messengerName]['deals'][singlePoint]);
                                self.$set(self.route.legs[index + 1], 'point', point.location);
                                self.$set(self.route.legs[index + 1], 'dialog', false)

                            })

                            self.$set(self.route.legs[0], 'data', {"index": index, "Contact_Type": "נהג"});
                            self.$set(self.route.legs[0], 'point', userLocation)
                            self.$set(self.route.legs[0], 'dialog', false)
                            self.$set(self.allMessengers,messengerName,{});
                            self.$set(self.allMessengers[messengerName], 'route', self.route);
                            self.route = null;
                        } else {
                            let data = {
                                text: 'Directions request failed due to ' + status,
                                status: 'error'
                            }
                            self.showSnackbar(data);
                        }
                    });
                }

                //loop through messengers and get directions per messenger
                let messengers_names = Object.keys(pointsToMap).sort();
                for (let index = 0; index < messengers_names.length; index++) {
                    let messenger = messengers_names[index];
                    let messengerLocation = pointsToMap[messenger]['location'];

                    if (pointsToMap[messenger]['deals'].length) {

                        let waypoints = pointsToMap[messenger]['deals']
                            .filter(w => w.Latitude && w.Longitude)
                            .map(w => {
                                return {
                                    stopover: true,
                                    location: new google.maps.LatLng(parseFloat(w.Latitude), parseFloat(w.Longitude)),
                                };
                        });
                        self.directionsService[index] = new google.maps.DirectionsService;
                        self.directionsDisplay[index] = new google.maps.DirectionsRenderer;
                        self.directionsDisplay[index].setMap(self.$refs.map.$mapObject);

                        if (waypoints && waypoints.length && messengerLocation) {
                            if(messenger === window.localStorage.getItem('Name') || window.localStorage.getItem('role') === 'admin') {
                                calculateAndDisplayRoute(messengerLocation, waypoints, pointsToMap, messenger, index);
                            }
                        }
                    }
                }

            },
            showLoader: function () {
                this.overlay = true;
            },
            showSnackbar: function (value) {
                this.overlay = false;
                this.snackBarClass = value.status;
                this.snackbarText = value.text;
                this.snackbar = true
            },
            getIcon: function (data) {

                switch (data.Contact_Type) {
                    case 'נהג':
                        let data1 = {
                            'url': '/images/truck_' + this.colors[data.index].toUpperCase() + '.png',
                            'size': {width: 40, height: 40, f: 'px', b: 'px'},
                            'scaledSize': {width: 40, height: 40, f: 'px', b: 'px'}
                        };
                        return data1;
                        break;
                    case 'מפיץ':
                        let data2 = {
                            'url': '/images/yellowMarker.png',
                            'size': {width: 24, height: 40, f: 'px', b: 'px'},
                            'fillColor':"yellow",
                            'labelOrigin': {x: 4, y: 15},
                            'scaledSize': {width: 24, height: 40, f: 'px', b: 'px'}
                        };
                        return data2;
                        break;
                    case 'לקוח פרטי':
                        let data3 = {
                            'url': '/images/redMarker.png',
                            'size': {width: 24, height: 40, f: 'px', b: 'px'},
                            'labelOrigin': {x: 4, y: 15},
                            'scaledSize': {width: 24, height: 40, f: 'px', b: 'px'}
                        };
                        return data3;
                        break;
                }
            },

            getLabel: function (point, index) {
                switch (point.Contact_Type) {
                    case 'נהג':
                    default:
                        return '';
                        break;
                    case 'מפיץ':
                    case 'לקוח פרטי':
                        return index.toString().padStart(2,'0')
                        break;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>


</style>
